import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GoogleAnalyticsEventsService } from '../../../services/google-analytics-events.service';
import { IcortexLocalizedPathService } from '../../../services/icortex-localized-path.service';
import { wfImage as wfImageFn } from '../wf-static';

@Component({
  standalone: true,
  selector: 'app-wf-main-content',
  imports: [ RouterModule ],
  templateUrl: './wf-main-content.component.html',
  styleUrls: [ './wf-main-content.component.css' ]
})
export class WfMainContentComponent {

  readonly wfImage = wfImageFn;

  private readonly icortexLocalizedPathService = inject( IcortexLocalizedPathService );

  protected readonly signupHref = this.icortexLocalizedPathService.getLocalizedPath( '/signup' );

  /** Índice del ítem FAQ abierto; `null` = todos cerrados (IX2 no enlaza este bloque en la SPA). */
  protected faqOpenIndex: number | null = null;

  private readonly googleAnalyticsEventsService = inject( GoogleAnalyticsEventsService );

  sendGAEvent( category: string, action: string, label: string, value?: number ): void {

    this.googleAnalyticsEventsService.emitEvent( category, action, label, value );
  }

  protected toggleFaq( index: number ): void {

    this.faqOpenIndex = this.faqOpenIndex === index ? null : index;
  }

  protected onFaqQuestionKeydown( event: KeyboardEvent, index: number ): void {

    if ( event.key === 'Enter' || event.key === ' ' ) {

      event.preventDefault();
      this.toggleFaq( index );
    }
  }

  protected localizedPath( path: string ): string {

    return this.icortexLocalizedPathService.getLocalizedPath( path );
  }

}
